import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { Flex, Icon, Expandable } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import GoalMatrixRowForm from './GoalMatrixRowForm';
import { capitalize } from 'helpers/content';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import { ColorLabel, ColorLabelContainer } from 'UI';
import sniffer from 'sniffer';

var GoalMatrixForm = function GoalMatrixForm(props) {
  var _props$part$value$row, _props$part;

  var translate = useTranslate();

  var _useState = useState((_props$part$value$row = (_props$part = props.part) === null || _props$part === void 0 ? void 0 : _props$part.value.rows) !== null && _props$part$value$row !== void 0 ? _props$part$value$row : []),
      _useState2 = _slicedToArray(_useState, 2),
      rows = _useState2[0],
      setRows = _useState2[1];

  useEffect(function () {
    if (rows.length == 0) {
      var _rows = [];

      _rows.push({
        index: _rows.length,
        id: 0,
        title: '',
        description: '',
        cells: [{
          index: 0,
          type: 'NotAchievedTextField',
          value: translate('Not achieved'),
          id: 0
        }]
      });

      setRows(_rows);
    }
  }, []); // onChange

  useEffect(function () {
    if (props.onChange != null) {
      var _props$part2;

      props.onChange(_objectSpread(_objectSpread({}, props.part), {}, {
        value: _objectSpread(_objectSpread({}, (_props$part2 = props.part) === null || _props$part2 === void 0 ? void 0 : _props$part2.value), {}, {
          rows: rows
        })
      }));
    }
  }, [rows]);

  var onRowChange = function onRowChange(row) {
    if (row == null) {
      return false;
    }

    var changedRows = _toConsumableArray(rows);

    changedRows.splice(row.index, 1, row);
    setRows(changedRows);
  };

  var removeMatrix = function removeMatrix() {
    if (props.onRemove != null) {
      props.onRemove();
    }
  };
  /**
   * @param {string} target
   * @param {string} referenceType
   * @description Toggles target permission on part data
   */


  var togglePermission = function togglePermission(target, referenceType) {
    var _props$part$permissio;

    var permissions = props.part.permissions;
    var indexOf = (_props$part$permissio = props.part.permissions) === null || _props$part$permissio === void 0 ? void 0 : _props$part$permissio.findIndex(function (element) {
      return element.target == target && element.referenceType == referenceType;
    });

    if (indexOf > -1) {
      permissions.splice(indexOf, 1);
    } else {
      permissions.push({
        target: target,
        referenceType: referenceType,
        level: 'READ'
      });
    }

    props.onChange(_objectSpread(_objectSpread({}, props.part), {}, {
      permissions: permissions
    }));
  };
  /**
   * @param {string} target
   */


  var renderPermission = function renderPermission(target) {
    var _props$part$permissio2;

    var active = ((_props$part$permissio2 = props.part.permissions) === null || _props$part$permissio2 === void 0 ? void 0 : _props$part$permissio2.find(function (element) {
      return element.target == target && element.referenceType == 'ASSESSMENTBLOCKPART';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active",
      onClick: function onClick(event) {
        event.stopPropagation();
        togglePermission(target, 'ASSESSMENTBLOCKPART');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? 'Eye' : 'Eye_Off'
    }), translate(capitalize(target)));
  };

  var renderAssessmentFeedbackPermission = function renderAssessmentFeedbackPermission() {
    var _props$part$permissio3;

    var active = ((_props$part$permissio3 = props.part.permissions) === null || _props$part$permissio3 === void 0 ? void 0 : _props$part$permissio3.find(function (element) {
      return element.target == 'GUARDIAN' && element.referenceType == 'ASSESSMENTFEEDBACK';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active",
      onClick: function onClick(event) {
        event.stopPropagation();
        togglePermission('GUARDIAN', 'ASSESSMENTFEEDBACK');
      }
    }, props.assessmentType == ASSESSMENT_TYPES.TEACHER && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize('Show feedback for guardians'))));
  };

  var renderRowTitle = function renderRowTitle() {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic"
    }, /*#__PURE__*/React.createElement("div", {
      className: "goalMatrix-Title-Header"
    }, /*#__PURE__*/React.createElement("span", null, translate('Goal')), props.course.length > 0 ? props.course.map(function (course) {
      var title = course.value.year != null ? "".concat(course.value.title, " ").concat(course.value.year) : course.value.title;
      return /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        key: course.value.id,
        tooltip: title,
        color: course.value.colorCode
      }));
    }) : null), props.assessmentType == ASSESSMENT_TYPES.TEACHER && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row-tools"
    }, renderPermission('STUDENT')), /*#__PURE__*/React.createElement("div", {
      className: "row-tools"
    }, renderPermission('GUARDIAN'))), props.disableRows == null || props.disableRows.length == 0 ? /*#__PURE__*/React.createElement("div", {
      className: "controls row-tools"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: removeMatrix
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Bin"
    }))) : null);
  };

  var getRowDisabled = function getRowDisabled(id) {
    var _props$part$assessmen;

    if (props.disableRows == null || props.disableRows.length == 0) {
      return false;
    }

    var reference = (_props$part$assessmen = props.part.assessmentBlockPartRows) === null || _props$part$assessmen === void 0 ? void 0 : _props$part$assessmen.find(function (partRow) {
      return partRow.referenceId == id;
    });

    if (reference == null) {
      return false;
    }

    return props.disableRows.indexOf(reference.id) > -1;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "goal-matrix-form"
  }, /*#__PURE__*/React.createElement(Expandable, {
    title: renderRowTitle(),
    color: "#0f78da",
    open: true,
    ignorePropsUpdate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "guardian-feedback-permission"
  }, renderAssessmentFeedbackPermission()), props.disabled ? /*#__PURE__*/React.createElement("div", {
    className: "disabled-notice"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Alert",
    bw: true
  }), translate('To be able to edit, you must first delete the assessments made.')) : null, /*#__PURE__*/React.createElement(Flex, {
    center: !sniffer.isPhone,
    column: sniffer.isPhone
  }, rows.map(function (row, index) {
    return /*#__PURE__*/React.createElement(GoalMatrixRowForm, {
      onChange: onRowChange,
      key: index,
      row: row,
      disabled: getRowDisabled(row.id)
    });
  }))));
};

GoalMatrixForm.defaultProps = {
  assessments: [],
  disabled: false
};
export default GoalMatrixForm;